import {observer} from 'mobx-react-lite'
import React from 'react'
import {rightPanelStore} from '@components/right-panel/right-panel'
import {cn} from '@containers/html-utils'
import {TaskWithColor} from '../../calendar-store'
import {useDraggableStore} from '../draggable/draggable-store'
import {TaskContent} from './task-content'

export const TaskWithoutStartDate = observer(
  ({
    drag,
    task,
    top,
    height,
    currentTime,
    changeDeadlineExpansion,
    pointerEventsNone
  }: {
    drag: boolean
    task: TaskWithColor
    top: number
    height: number
    currentTime: Date
    changeDeadlineExpansion: boolean
    pointerEventsNone: boolean
  }) => {
    const [draggableState] = useDraggableStore()
    return (
      <div
        className={cn(
          'absolute z-10 flex w-full hover:z-20',
          pointerEventsNone && 'pointer-events-none'
        )}
        style={{
          top,
          opacity:
            draggableState.enabled &&
            draggableState.draggedItem.id === task.task.id &&
            0
        }}
      >
        <div
          className="relative w-3 h-3 -ml-2 rounded-full bg-accent-old"
          style={{
            top: 13
          }}
        />
        <div
          className="relative w-full"
          style={{
            marginLeft: `${task.marginShiftLeft * 10}%`
          }}
        >
          <div
            style={{
              color:
                rightPanelStore.state.currentChat?.id !== task.task.id &&
                `${task.columnColor}${'e6'}`,
              fillOpacity: task.roundedDeadline > currentTime ? 1 : 0.65
            }}
            className="absolute z-10 top-6 text-accent-old"
          >
            {triangleSVGwithTwoDifferentCurrentColors()}
          </div>
          <div
            className="absolute ml-8 left-1"
            style={{
              width: 'calc(100% - 10px)'
            }}
          >
            <TaskContent
              allDay={false}
              task={task}
              type="without-start-date"
              dragWithoutStartDate={drag}
              drag={drag}
              height={height}
              className="leading-7"
              changeDeadlineExpansion={changeDeadlineExpansion}
            />
          </div>
        </div>
      </div>
    )
  }
)

const triangleSVGwithTwoDifferentCurrentColors = () => {
  return (
    <svg width="10" height="20" viewBox="0 0 10 20" fill="none">
      <g filter="url(#filter0_d_3977_39544)">
        <path
          d="M6 9L10 5L14 9L10 13L6 9Z"
          fill="currentColor"
          shapeRendering="crispEdges"
        />
        <svg className="text-bg-main-old">
          <path
            d="M5.64645 8.64645L5.29289 9L5.64645 9.35355L9.64645 13.3536L10 13.7071L10.3536 13.3536L14.3536 9.35355L14.7071 9L14.3536 8.64645L10.3536 4.64645L10 4.29289L9.64645 4.64645L5.64645 8.64645Z"
            stroke="currentColor"
            shapeRendering="crispEdges"
          />
        </svg>
      </g>
      <defs>
        <filter
          id="filter0_d_3977_39544"
          x="0.585938"
          y="0.585815"
          width="18.8281"
          height="18.8284"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_3977_39544"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_3977_39544"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  )
}
